/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Realitni_SeoInputs */

const cs_enum_realitni_seo = /** @type {(inputs: Enum_Realitni_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RealitníSEO`)
};

const en_enum_realitni_seo = /** @type {(inputs: Enum_Realitni_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RealitniSEO`)
};

/**
* | output |
* | --- |
* | "RealitniSEO" |
*
* @param {Enum_Realitni_SeoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_realitni_seo = /** @type {((inputs?: Enum_Realitni_SeoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Realitni_SeoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_realitni_seo(inputs)
	return cs_enum_realitni_seo(inputs)
});